<nav class="navbar fixed-top navbar-expand-lg navbar-gov-co">
  <div class="navbar-gov-co-pri container-fluid">
    <div class="navbar-logo float-left">
      <a class="navbar-brand" href="https://www.gov.co/" target="_blank" rel="noopener">
        <img src="https://cdn.www.gov.co/assets/images/logo.png" height="30" alt="Logo Gov.co" />
      </a>
      <button
        class="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbarCollapsible"
        aria-controls="navbarCollapsible"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button>
    </div>
    <div class="collapse navbar-collapse navbar-first-menu float-right">
      <div class="nav-primary mx-auto">
        <ul class="navbar-nav ml-auto nav-items nav-items-desktop"></ul>
      </div>
      <!--<div class="nav-item-primary ml-auto mr-2">
        <span class="govco-icon govco-icon-language-en-n lang-govco ml-3"></span>
      </div>-->
    </div>

    <!-- user-->
    <div class="nav-item-primary ml-auto mr-2 is-scroll" *ngIf="currentUser">
      <div class="d-flex" style="color: white; font-weight: bold; padding: 5px">
        <img class="default-img-profile"
             src="./assets/icons/default_user.jpg" alt="User">
          <span class="profile-user-name"> {{ currentUser?.name || (currentUser?.family_name + ' ' + currentUser?.given_name) }}
          </span>
          <span class="govco-icon govco-icon-right-arrow-n lang-govco ml-3 btn-logout"
                title="Cerrar Sesión"
                (click)="setLogout()"></span>
      </div>
    </div>
    <!-- user-->

  </div>
  <!--<div class="navbar-nav navbar-notifications" id="notificationHeader"></div>-->

  <!--<nav class="navbar navbar-gov-co-sedes" *ngIf="currentUser">
    <div class="nav-secondary show-transition navbar-navs" id="nav-secondary">
      <div class="container">
        <div class="navbar-first-menu">
          <ul class="navbar-nav w-100 d-flex nav-items nav-items-desktop">
            <li class="nav-item">
              <a [routerLink]="[routes.Dashboard]" class="nav-link">Bandeja de entrada</a>
            </li>
            <li class="nav-item item-menu-single">
              <a href="#" class="nav-link" id="menuSingleAcceso" role="button" data-toggle="dropdown"
                 aria-haspopup="true" aria-expanded="false">Trámites y servicios
              </a>
              <div class="dropdown-menu single-menu" aria-labelledby="menuSingleAcceso">
                <a [routerLink]="[routes.AddRequestProcedure16]">Trámite 16</a>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="navbar-nav navbar-notifications" id="notificationHeader"></div>
  </nav>-->
</nav>

<div class="navbar-gov-co-search">
  <div class="content-logo" style="background-color: #FFFFFF!important;">
    <!--<span> Logo Autoridad </span>-->
    <img src="./assets/images/logoSDS.png" alt="Secretaria Distrital de Salud">
    <!-- ./assets/images/logoSDS.png -->
  </div>
</div>
